import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-3">
              联系我们
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              好剧推荐与商务合作
            </p>
          </div>

          <div className="bg-background-100 border border-background-200/70 rounded-lg p-6 md:p-10">
            <div className="text-center mb-6 md:mb-8">
              <h3 className="text-lg md:text-xl font-heading text-foreground-900 mb-3">
                {contactData.title}
              </h3>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-2xl mx-auto">
                {contactData.description}
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 md:gap-12">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-md bg-primary-100 flex items-center justify-center text-primary-600 text-lg">
                  <i className="ri-mail-line"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-400 mb-0.5">电子邮箱</p>
                  <p className="text-sm md:text-base text-foreground-800 font-medium">
                    {contactData.email}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-md bg-accent-100 flex items-center justify-center text-accent-600 text-lg">
                  <i className="ri-wechat-line"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-400 mb-0.5">微信</p>
                  <p className="text-sm md:text-base text-foreground-800 font-medium">
                    {contactData.wechat}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}